export default __webpack_public_path__ + "static/media/img-0126-france-half-face.0972583b.png";